import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/solid/{S,M,L}/user.svg` */
export const UserSolidIcon = createTripletGlyphIcon('UserSolidIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.98773 1.60608C9.81329 1.60642 11.2933 3.08764 11.2934 4.9137C11.2934 5.97212 10.7954 6.91368 10.0219 7.51917C12.7151 7.92991 14.0408 10.4387 14.5844 12.2985C14.9175 13.4389 13.9794 14.3941 12.9155 14.3942H3.09222C2.04925 14.3941 1.09329 13.4638 1.41058 12.3248C2.26559 9.25863 4.64457 7.86876 5.96331 7.52698C5.18421 6.92181 4.68208 5.97673 4.68206 4.9137C4.68218 3.08743 6.16187 1.60608 7.98773 1.60608Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.98552 1.80682C11.0394 1.80688 12.7039 3.47317 12.7043 5.52753C12.7043 6.71773 12.1449 7.77682 11.2756 8.45819C14.3045 8.92073 15.7949 11.7431 16.4064 13.8351C16.7815 15.1183 15.7265 16.1926 14.5295 16.1926H3.47869C2.30526 16.1924 1.22879 15.1459 1.58611 13.8644C2.54761 10.4168 5.22224 8.85339 6.70622 8.46796C5.8304 7.78694 5.26677 6.72295 5.26677 5.52753C5.2671 3.47314 6.93155 1.80682 8.98552 1.80682Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.98 2.40918C14.7186 2.40918 16.9386 4.63093 16.939 7.37012C16.939 8.95731 16.1923 10.369 15.0327 11.2773C19.0728 11.8932 21.06 15.6574 21.8755 18.4473C22.3755 20.1582 20.9687 21.5908 19.3726 21.5908H4.6382C3.07368 21.5906 1.63849 20.1949 2.11476 18.4863C3.39698 13.8884 6.96446 11.8034 8.94289 11.29C7.77464 10.3821 7.02199 8.96431 7.02199 7.37012C7.02242 4.63116 9.24169 2.40956 11.98 2.40918Z"
        fill="currentColor"
      />
    </svg>
  ),
});
